import { useTranslation } from 'react-i18next';
import { Chip } from '@/shared/ui/chips/Chip';
import type { CargoIdEntityType } from '@/shared/types/api/cargo-id';

type Props = {
  type: CargoIdEntityType;
  className?: string;
};

const TYPE_STYLES: Record<CargoIdEntityType, string> = {
  PHYSICAL: 'bg-sky-100 text-sky-800 border-sky-200',
  LEGAL: 'bg-indigo-100 text-indigo-800 border-indigo-200',
};

export const CargoIdTypeBadge = ({ type, className }: Props) => {
  const { t } = useTranslation();
  return (
    <Chip tone={TYPE_STYLES[type]} className={className}>
      {t(`cargoIdType.${type}`)}
    </Chip>
  );
};
